"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[36902],{

/***/ 83100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38597);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(331);








var initialState = {
    tab: "order",
    isFilterActive: false,
    orderSearchValue: {
        action: "",
        stock: "",
        text: ""
    },
    orderSearchOptions: [],
    orderFilterValue: {
        status: [],
        orderType: [],
        expiry: [],
        accountType: []
    },
    orderSearchFilterResult: []
};
var orderTableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, initialState), {
        setOrderTab: function(tab) {
            set({
                tab: tab
            });
        },
        setOrderSearchValue: function(orderSearchValue) {
            if (orderSearchValue === null) {
                set({
                    orderSearchValue: initialState.orderSearchValue
                });
                return;
            }
            set({
                orderSearchValue: orderSearchValue
            });
        },
        setOrderSearchOptions: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(stock) {
                var ref, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(stock === null)) {
                                _ctx.next = 3;
                                break;
                            }
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                            return _ctx.abrupt("return");
                        case 3:
                            _ctx.prev = 3;
                            ;
                            _ctx.next = 7;
                            return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchEmiten */ .Z.getSearchEmiten(stock);
                        case 7:
                            data = _ctx.sent.data;
                            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.company) {
                                set({
                                    orderSearchOptions: data.data.company.map(function(d) {
                                        return {
                                            name: d === null || d === void 0 ? void 0 : d.name,
                                            desc: d === null || d === void 0 ? void 0 : d.desc
                                        };
                                    })
                                });
                            }
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(stock) {
                return _ref.apply(this, arguments);
            };
        }(),
        setOrderFilterValue: function(orderFilterValue) {
            if (orderFilterValue === null) {
                set({
                    orderFilterValue: initialState.orderFilterValue
                });
                return;
            }
            set({
                orderFilterValue: orderFilterValue
            });
        },
        searchAndFilter: function(source) {
            if (source === null) {
                set({
                    orderSearchFilterResult: source
                });
                return;
            }
            var ref = get(), orderSearchValue = ref.orderSearchValue, orderFilterValue = ref.orderFilterValue;
            var searchResult = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .search */ .yC)(source, orderSearchValue);
            var searchFilterResult = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)(searchResult, orderFilterValue);
            set({
                orderSearchFilterResult: searchFilterResult,
                isFilterActive: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .checkFilterAvailability */ .XI)(orderFilterValue)
            });
        },
        resetOrderTableStore: function() {
            set(initialState);
        }
    });
}, {
    name: "zustandOrderTableStore",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            isFilterActive: state.isFilterActive,
            orderSearchValue: state.orderSearchValue,
            orderFilterValue: state.orderFilterValue
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (orderTableStore);


/***/ }),

/***/ 331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ splitSearch; },
/* harmony export */   "Gd": function() { return /* binding */ checkIsCancelable; },
/* harmony export */   "XI": function() { return /* binding */ checkFilterAvailability; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "v1": function() { return /* binding */ checkIsAmendable; },
/* harmony export */   "yC": function() { return /* binding */ search; }
/* harmony export */ });
/* harmony import */ var global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6421);

var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(v, f) {
            return f(v);
        }, x);
    };
};
var splitSearch = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedStock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var arrSearch = search.split(" ");
    if (arrSearch.length === 1) {
        return {
            action: selectedStock || arrSearch[0],
            stock: selectedStock || arrSearch[0],
            text: selectedStock || arrSearch[0]
        };
    }
    if (arrSearch.length > 1) {
        return {
            action: arrSearch[0],
            stock: selectedStock || arrSearch[1],
            text: [
                arrSearch[0],
                selectedStock || arrSearch[1]
            ].join(" ")
        };
    }
    return {
        action: "",
        stock: "",
        text: ""
    };
};
var search = function(source, searchValue) {
    if (!searchValue) {
        return source;
    }
    var action = searchValue.action, stock = searchValue.stock;
    if (action !== "" && action === stock) {
        return source.filter(function(e) {
            return e.action.startsWith(action.toLocaleUpperCase()) || e.symbol.startsWith(action.toLocaleUpperCase());
        });
    }
    if (action !== "" && stock !== "") {
        return source.filter(function(e) {
            return action.toLocaleUpperCase() === e.action && e.symbol.startsWith(stock.toLocaleUpperCase());
        });
    }
    return source;
};
var filter = function(source, filterValue) {
    if (!filterValue) {
        return source;
    }
    var status = filterValue.status, orderType = filterValue.orderType, expiry = filterValue.expiry, _accountType = filterValue.accountType, accountType = _accountType === void 0 ? [] : _accountType;
    var filterFn = function(valueToCheck) {
        var filterValueItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if ((filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.length) === 0) {
            return true;
        }
        return filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.includes(valueToCheck);
    };
    var filterStatus = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.status) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase(), status);
        });
    };
    var filterOrderType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.label) === null || ref === void 0 ? void 0 : ref.toUpperCase(), orderType);
        });
    };
    var filterExpiry = function(s) {
        return s.filter(function(i) {
            return filterFn(i.gtc_text, expiry);
        });
    };
    var filterAccountType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.day_trade_is_day_trade) === null || ref === void 0 ? void 0 : ref.toString(), accountType);
        });
    };
    return pipe(filterStatus, filterOrderType, filterExpiry, filterAccountType)(source);
};
var checkFilterAvailability = function(filterValue) {
    var filterArr = Object.keys(filterValue).map(function(k) {
        var ref;
        return (ref = filterValue[k]) === null || ref === void 0 ? void 0 : ref.length;
    });
    return filterArr.some(function(i) {
        return i > 0;
    });
};
var SMART_ORDER_LABELS = new Set([
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.SL */ .D0.SL,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.TP */ .D0.TP,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.TS */ .D0.TS,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.AB */ .D0.AB,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.LIT_SELL */ .D0.LIT_SELL,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.BO */ .D0.BO, 
]);
var isSmartOrder = function(label) {
    return SMART_ORDER_LABELS.has(label);
};
var checkIsCancelable = function(item) {
    return isSmartOrder(item.label) ? item.cancel_target !== "ACTION_TARGET_UNSPECIFIED" : item.cancel_action;
};
var checkIsAmendable = function(item) {
    return isSmartOrder(item.label) ? item.amend_target !== "ACTION_TARGET_UNSPECIFIED" : item.amend_action;
};



/***/ }),

/***/ 8992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ securitiesStorageKey; }
/* harmony export */ });
var securitiesStorageKey = {
    tradeIsLogin: "tradeIsLogin",
    accessToken: "securitiesAccessToken",
    refreshToken: "securitiesRefreshtoken",
    targetAPI: "securitiesTarget",
    stockbitFormula: "formulaStockbit"
};


/***/ }),

/***/ 6421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ SmartOrderLabel; },
/* harmony export */   "ax": function() { return /* binding */ ORDER_TYPE_VALUE_TEXT; },
/* harmony export */   "by": function() { return /* binding */ EventTypeEnum; },
/* harmony export */   "n5": function() { return /* binding */ TradingFeatureEnum; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var TradingFeatureEnum;
(function(TradingFeatureEnum) {
    TradingFeatureEnum["UNSPECIFIED"] = "FEATURE_UNSPECIFIED";
    TradingFeatureEnum["DAY_TRADE"] = "FEATURE_DAY_TRADE";
    TradingFeatureEnum["SPLIT_ORDER"] = "FEATURE_SPLIT_ORDER";
})(TradingFeatureEnum || (TradingFeatureEnum = {}));
var EventTypeEnum;
(function(EventTypeEnum) {
    EventTypeEnum["UNSPECIFIED"] = "EVENT_TYPE_UNSPECIFIED";
    EventTypeEnum["OUTSIDE_MARKET_HOURS"] = "EVENT_TYPE_DISABLE_OUTSIDE_MARKET_HOURS";
    EventTypeEnum["EXCEED_DEBT_RATIO"] = "EVENT_TYPE_DISABLE_EXCEED_DEBT_RATIO";
})(EventTypeEnum || (EventTypeEnum = {}));
var SmartOrderLabel;
(function(SmartOrderLabel) {
    SmartOrderLabel["TP"] = "TP";
    SmartOrderLabel["SL"] = "SL";
    SmartOrderLabel["MO"] = "MO";
    SmartOrderLabel["TS"] = "TS";
    SmartOrderLabel["AB"] = "AB";
    SmartOrderLabel["BO"] = "BO";
    SmartOrderLabel["LIT_SELL"] = "LIT_SELL";
})(SmartOrderLabel || (SmartOrderLabel = {}));
var _obj;
var ORDER_TYPE_VALUE_TEXT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.TP, "Take Profit"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.SL, "Stop Loss"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.TS, "Trailing Stop"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.AB, "Limit If Touched"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.LIT_SELL, "Limit If Touched"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.BO, "Bracket Limit Order"), _obj);


/***/ }),

/***/ 98202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ getSellAmountInvestedFee; },
/* harmony export */   "J0": function() { return /* binding */ getLimitLot; },
/* harmony export */   "Oz": function() { return /* binding */ generateUpdatedPortfolioHeader; },
/* harmony export */   "Sd": function() { return /* binding */ getSellGain; },
/* harmony export */   "fY": function() { return /* binding */ getProfitLoss; },
/* harmony export */   "jm": function() { return /* binding */ generateUpdatedPortfolioItem; },
/* harmony export */   "yq": function() { return /* binding */ getBuyAmountInvested; }
/* harmony export */ });
/* unused harmony exports getConfigFormula, getBuyAmountInvestedFee */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var _constants_localStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8992);
/* eslint-disable no-new-func */ 

var getConfigFormula = function() {
    var ref;
    return ((ref = JSON.parse(localStorage.getItem(_constants_localStorage__WEBPACK_IMPORTED_MODULE_0__/* .securitiesStorageKey.stockbitFormula */ .O.stockbitFormula))) === null || ref === void 0 ? void 0 : ref.formula) || {};
};
var getSellAmountInvestedFee = function(lot, price, isCorporateAction) {
    var isDayTrade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref = getConfigFormula(), sellAmountInvestedFee = ref.sell_amount_invested_fee, caSellAmountInvestedFee = ref.ca_sell_amount_invested_fee, feeSell = ref.fee_sell, feeBuy = ref.fee_buy, feeBuyDayTrade = ref.fee_buy_day_trade, feeSellDayTrade = ref.fee_sell_day_trade;
    var FEE_BUY = isDayTrade ? feeBuyDayTrade : feeBuy;
    var FEE_SELL = isDayTrade ? feeSellDayTrade : feeSell;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price, ",").concat(isCorporateAction ? "FEE_BUY=".concat(FEE_BUY) : "FEE_SELL=".concat(FEE_SELL)), "return ".concat(isCorporateAction ? caSellAmountInvestedFee : sellAmountInvestedFee))();
};
var getBuyAmountInvested = function(lot, price) {
    var ref = getConfigFormula(), buyAmountInvested = ref.buy_amount_invested;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price), "return ".concat(buyAmountInvested))();
};
var getBuyAmountInvestedFee = function(lot, price) {
    var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref = getConfigFormula(), buyAmountInvestedFee = ref.buy_amount_invested_fee, feeBuy = ref.fee_buy, feeBuyDayTrade = ref.fee_buy_day_trade;
    var FEE_BUY = isDayTrade ? feeBuyDayTrade : feeBuy;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price, ",FEE_BUY=").concat(FEE_BUY), "return ".concat(buyAmountInvestedFee))();
};
var getProfitLoss = function(sellAmountInvestedFee, buyAmountInvestedAveragePriceFee) {
    var ref = getConfigFormula(), sellProfitLoss = ref.sell_profit_loss;
    return new Function("SELL_AMOUNT_INVESTED_FEE=".concat(sellAmountInvestedFee, ",BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE=").concat(buyAmountInvestedAveragePriceFee), "return ".concat(sellProfitLoss))();
};
var getSellGain = function(sellProfitLoss, buyAmountInvestedAveragePriceFee) {
    var ref = getConfigFormula(), sellGain = ref.sell_gain;
    return new Function("SELL_PROFITLOSS=".concat(sellProfitLoss, ",BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE=").concat(buyAmountInvestedAveragePriceFee), "return ".concat(sellGain))() * 100;
};
var getLimitLot = function(balance, price) {
    var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var priceWithFee = getBuyAmountInvestedFee(1, price, isDayTrade);
    var limitLot = Math.floor(balance / priceWithFee);
    return limitLot < 0 ? 0 : limitLot;
};
var generateUpdatedPortfolioItem = function(configFormula, lastPrice, balanceLot, amountInvested) {
    var formula = configFormula.formula;
    var LOT = balanceLot;
    var CURRENT_PRICE = lastPrice;
    var AMOUNT_INVESTED = amountInvested;
    var unrealised_market_value = new Function("LOT", "CURRENT_PRICE", "return ".concat(formula.unrealised_market_value, ";"))(LOT, CURRENT_PRICE);
    var UNREALISED_MARKET_VALUE = unrealised_market_value;
    var unrealised_profit_loss = new Function("UNREALISED_MARKET_VALUE", "AMOUNT_INVESTED", "return ".concat(formula.unrealised_profit_loss, ";"))(UNREALISED_MARKET_VALUE, AMOUNT_INVESTED);
    var UNREALISED_PROFIT_LOSS = unrealised_profit_loss;
    var unrealised_gain = new Function("UNREALISED_PROFIT_LOSS", "AMOUNT_INVESTED", "return ".concat(formula.unrealised_gain, ";"))(UNREALISED_PROFIT_LOSS, AMOUNT_INVESTED);
    return {
        unrealised_marketvalue: unrealised_market_value,
        unrealised_profitloss: unrealised_profit_loss,
        unrealised_gain: unrealised_gain
    };
};
var generateUpdatedPortfolioHeader = function(configFormula) {
    var result = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], tradingBalance = arguments.length > 3 ? arguments[3] : void 0, amountInvested = arguments.length > 4 ? arguments[4] : void 0, amountAllocated = arguments.length > 5 ? arguments[5] : void 0, totalDebt = arguments.length > 6 ? arguments[6] : void 0;
    var formula = configFormula.formula;
    var combinedResult = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(result).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dayTrade));
    var unrealised_profitloss = combinedResult.reduce(function(sum, item) {
        return item.unrealised_profitloss !== undefined ? sum + item.unrealised_profitloss : sum;
    }, 0);
    var SUMMARY_NET_PROFIT_LOSS = unrealised_profitloss;
    var TRADING_BALANCE = tradingBalance;
    var SUMMARY_OPEN = amountAllocated;
    var SUMMARY_INVESTED = amountInvested;
    var gain = new Function("SUMMARY_NET_PROFIT_LOSS", "TRADING_BALANCE", "SUMMARY_OPEN", "SUMMARY_INVESTED", "return ".concat(formula.summary_net_profit_loss_percentage, ";"))(SUMMARY_NET_PROFIT_LOSS, TRADING_BALANCE, SUMMARY_OPEN, SUMMARY_INVESTED);
    var equity = new Function("SUMMARY_NET_PROFIT_LOSS", "TRADING_BALANCE", "SUMMARY_OPEN", "SUMMARY_INVESTED", "return ".concat(formula.summary_equity, ";"))(SUMMARY_NET_PROFIT_LOSS, TRADING_BALANCE, SUMMARY_OPEN, SUMMARY_INVESTED);
    var unrealised_market_value_day_trade = dayTrade.reduce(function(sum, item) {
        return item.unrealised_marketvalue !== undefined ? sum + item.unrealised_marketvalue : sum;
    }, 0);
    var TOTAL_DEBT = totalDebt;
    var DAY_TRADE_MARKET_VALUE = unrealised_market_value_day_trade;
    var ratio = new Function("TOTAL_DEBT", "DAY_TRADE_MARKET_VALUE", "return ".concat(formula.day_trade_debt_ratio, ";"))(TOTAL_DEBT, DAY_TRADE_MARKET_VALUE);
    return {
        unrealised_profitloss: unrealised_profitloss,
        gain: gain,
        equity: equity,
        ratio: ratio * 100,
        market_value: DAY_TRADE_MARKET_VALUE
    };
};


/***/ }),

/***/ 79397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cf": function() { return /* binding */ getVirtualOrderList; },
  "__": function() { return /* binding */ postVirtualAmendOrder; },
  "$C": function() { return /* binding */ postVirtualOrder; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/order.ts
var orderEndpoints = {
    list: function() {
        return "/virtualtrading/order";
    },
    create: function(type, symbol) {
        return "/virtualtrading/".concat(type, "/").concat(symbol);
    },
    amend: function() {
        return "/virtualtrading/amend";
    }
};
/* harmony default export */ var order = (orderEndpoints);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/order.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getVirtualOrderList = function() {
    return defaultInstance.get(order.list());
};
var postVirtualOrder = function(orderType, symbol, payload) {
    return defaultInstance.post(order.create(orderType, symbol), payload);
};
var postVirtualAmendOrder = function(payload) {
    return defaultInstance.post(order.amend(), payload);
};


/***/ }),

/***/ 80943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ getPortfolioDetail; },
  "g": function() { return /* binding */ getPortfolioList; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/portfolio.ts
var portfolioEndpoint = {
    detail: function(symbol) {
        return "/virtualtrading/portfolio/".concat(symbol);
    },
    list: function() {
        return "/virtualtrading/portfolio";
    }
};
/* harmony default export */ var portfolio = (portfolioEndpoint);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/portfolio.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getPortfolioDetail = function(symbol) {
    return defaultInstance.get(portfolio.detail(symbol));
};
var getPortfolioList = function() {
    return defaultInstance.get(portfolio.list());
};


/***/ }),

/***/ 83384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* eslint-disable import/named */ /* eslint-disable no-undef */ 


var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
// APIs
var ORDERBOOK_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/orderbook");
// EXODUS APIs
var EXODUS_ORDERBOOK_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/orderbook");
// Should be replaced with get company orderbook data but the exodus endpoint
// doesn't support special symbols e.g. IHSG
var getOrderbookPreviewBySymbol = function(symbol) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/company-price-feed/v2/orderbook/companies/").concat(symbol));
};
var getOrderbookList = function() {
    return requestExodus.get(EXODUS_ORDERBOOK_API);
};
var createOrderbookList = function(param) {
    var orderbookName = param.orderbookName;
    return requestExodus.post(EXODUS_ORDERBOOK_API, {
        name: orderbookName
    });
};
var editOrderbookList = function(param) {
    var id = param.id, orderbookName = param.orderbookName, symbols = param.symbols;
    var params = {
        name: orderbookName
    };
    if (symbols) params.symbols = symbols;
    return requestExodus.put("".concat(EXODUS_ORDERBOOK_API, "/").concat(id), params);
};
var deleteOrderbookList = function(param) {
    var id = param.id;
    return requestExodus.delete("".concat(EXODUS_ORDERBOOK_API, "/").concat(id));
};
var getOrderbookListItem = function(id) {
    if (id) {
        return requestExodus.get("/company-price-feed/v2/orderbook/template/".concat(id));
    }
    // Get default orderbook if ID is not passed
    // Harusnya nantinya ada lebih lanjut terkait ini sih, gimana kalo enggak ada ID nya
    return requestExodus.get(ORDERBOOK_API);
};
var getCompanyInfo = function(symbol) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/emitten/").concat(symbol, "/info"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getOrderbookPreviewBySymbol: getOrderbookPreviewBySymbol,
    getOrderbookList: getOrderbookList,
    createOrderbookList: createOrderbookList,
    editOrderbookList: editOrderbookList,
    deleteOrderbookList: deleteOrderbookList,
    getOrderbookListItem: getOrderbookListItem,
    getCompanyInfo: getCompanyInfo
});


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradingData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/lib/api/orderbook.ts
var orderbook = __webpack_require__(83384);
// EXTERNAL MODULE: ./src/lib/api/securities.ts
var securities = __webpack_require__(65906);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/global/Securities/utils/formula.ts
var formula = __webpack_require__(98202);
// EXTERNAL MODULE: ./src/utils/securities/transformData.ts
var transformData = __webpack_require__(75413);
;// CONCATENATED MODULE: ./src/utils/securities/transformVirtualTradingData.ts


var vtOrderList = function(data) {
    return data.map(function(item) {
        return {
            action: item.action,
            amount_fee: item.amount.fee,
            amount_invested: item.amount.invested,
            amount_matched: item.amount.matched,
            currency: item.currency,
            gtc: item.gtc.enable ? 1 : 0,
            gtc_expired: item.gtc.expired,
            gtc_status: item.gtc.status,
            order_done: item.done,
            order_open: item.open,
            order_total: item.total,
            orderid: item.id,
            market_orderid: item.market_order_id,
            price: item.price,
            price_average: item.price_average,
            status: item.status,
            symbol: item.symbol,
            time: item.time.created,
            time_open: item.time.open,
            time_match: item.time.match,
            total: item.total,
            platform_order_type: item.platform_order_type,
            smart_order_bracket_order_child: [],
            smart_order_parent_id: "",
            smart_order_parent_price: 0,
            message: item === null || item === void 0 ? void 0 : item.message
        };
    });
};
var vtPortfolioList = function(data) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        // transform to the legacy schema
        tradingbalance: data.trading_balance,
        amount_invested: data.amount.invested,
        amount_allocated: data.amount.allocated,
        amount_creditlimit: data.amount.credit_limit,
        unrealised_profitloss: data.profit_loss.unrealized,
        realised_profitloss: data.profit_loss.realized,
        profitloss: data.profit_loss.total,
        equity: data.equity,
        gain: data.gain,
        // transform to the legacy schema
        result: data.result.map(function(item) {
            return {
                available_lot: item.available_lot,
                balance_lot: item.balance_lot,
                symbol: item.symbol,
                sell_open: item.sell_open.total,
                sell_open_today: item.sell_open.today,
                total: item.total,
                price: item.price.order,
                price_average: item.price.average,
                price_latest: item.price.market,
                unrealised_marketvalue: item.unrealized.market_value,
                unrealised_profitloss: item.unrealized.profit_loss,
                unrealised_gain: item.unrealized.gain,
                name: item.name
            };
        })
    });
};
/* harmony default export */ var transformVirtualTradingData = ({
    vtOrderList: vtOrderList,
    vtPortfolioList: vtPortfolioList
});

// EXTERNAL MODULE: ./src/global/VirtualTrading/api/order.ts + 1 modules
var order = __webpack_require__(79397);
// EXTERNAL MODULE: ./src/global/VirtualTrading/api/portfolio.ts + 1 modules
var portfolio = __webpack_require__(80943);
;// CONCATENATED MODULE: ./src/lib/stores/tradingData.ts
/* eslint-disable import/no-named-as-default-member */ 
















var defaultData = {
    isLoading: false,
    message: "",
    data: null,
    error: ""
};
var historyDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        data: [],
        page: "1",
        isNeedToFetchMore: false,
        totalRealizedAmount: 0,
        tooltipHeader: "",
        tooltips: []
    },
    showSkeleton: true
});
var transactionHistoryDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        history: []
    },
    showSkeleton: false
});
var portfolioDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        tradingbalance: 0,
        amount_invested: 0,
        amount_allocated: 0,
        unrealised_profitloss: 0,
        gain: 0,
        equity: 0,
        result: [],
        auto_order_info: "",
        // Day Trade
        day_trade: [],
        debt_ratio: 0,
        debt_total: 0,
        debt_market_value: 0
    }
});
var portfolioDetailDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        available_lot: 0,
        available_share: 0,
        exercise_data: {
            price: 0
        }
    }
});
var cashOnHandDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        available_cash_on_hand: 0
    }
});
var orderHistoryDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: []
});
var setIsLoading = function(key, set) {
    var custom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        isLoading: true
    })), false, "setIsLoading/".concat(key));
};
var setError = function(error, key, set) {
    var custom = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        error: error
    })), false, "setError/".concat(key));
};
var setData = function(data, message, key, set) {
    var custom = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        data: data,
        message: message
    })), false, "setData/".concat(key));
};
var tradingDataStore = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)((0,middleware/* persist */.tJ)((0,middleware/* subscribeWithSelector */.XR)(function(set, get) {
    return {
        portfolio: portfolioDefault,
        orderHistory: orderHistoryDefault,
        configFormula: defaultData,
        exerciseList: defaultData,
        history: historyDefault,
        transactionHistory: transactionHistoryDefault,
        company: defaultData,
        corpActions: defaultData,
        exercise: defaultData,
        cashOnHand: cashOnHandDefault,
        portfolioDetail: portfolioDetailDefault,
        portfolioDetailDayTrade: portfolioDetailDefault,
        rightTradeable: defaultData,
        stockTradable: defaultData,
        resetModalData: function() {
            set({
                rightTradeable: defaultData,
                exercise: defaultData,
                cashOnHand: cashOnHandDefault
            });
        },
        resetCompany: function() {
            set({
                company: defaultData
            });
        },
        setSkeleton: function(key, showSkeleton) {
            set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get()[key]), {
                showSkeleton: showSkeleton
            })));
        },
        getPortfolio: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isRealTrading) {
                var resetData, key, api, response, _$error, _data, responseData, message, data, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetData = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                            key = "portfolio";
                            if (resetData) setIsLoading(key, set, portfolioDefault);
                            _ctx.prev = 3;
                            api = !isRealTrading ? portfolio/* getPortfolioList */.g : trade/* default.getPortfolio */.Z.getPortfolio;
                            _ctx.next = 7;
                            return api();
                        case 7:
                            response = _ctx.sent;
                            if (!(response.data.error || !response.data)) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to get portfolio failed";
                            setError(_$error, key, set, portfolioDefault);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, responseData = _data.data, message = _data.message;
                            data = isRealTrading ? transformData/* default.portfolioList */.ZP.portfolioList(responseData) : transformVirtualTradingData.vtPortfolioList(responseData);
                            setData(data, message, key, set, portfolioDefault);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, portfolioDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        18
                    ]
                ]);
            }));
            return function(isRealTrading) {
                return _ref.apply(this, arguments);
            };
        }(),
        getConfigFormula: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, persistedFormula, response, _$error, _data, responseData, message, data, formulaStockbit;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "configFormula";
                        persistedFormula = get().configFormula;
                        setIsLoading(key, set, persistedFormula);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return trade/* default.getConfigFormula */.Z.getConfigFormula();
                    case 6:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        _$error = "Attempt to retrieve config formula failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 11:
                        _data = response.data, responseData = _data.data, message = _data.message;
                        data = transformData/* default.formulaData */.ZP.formulaData(responseData);
                        formulaStockbit = {
                            formula: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.formula), {
                                fee_buy: data.fee.buy,
                                fee_sell: data.fee.sell,
                                fee_buy_day_trade: data.day_trade.fee.buy,
                                fee_sell_day_trade: data.day_trade.fee.sell
                            })
                        };
                        localStorage.setItem("formulaStockbit", JSON.stringify(formulaStockbit));
                        localStorage.setItem("securitiesPreviewFeeData", JSON.stringify(data.preview_fee));
                        localStorage.setItem("securitiesPreviewFeeDataDayTrade", JSON.stringify(data.day_trade.preview_fee));
                        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formulaStockbit), {
                            preview_fee: data.preview_fee,
                            day_trade: data.day_trade
                        }), message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](3);
                        setError(_ctx.t0, key, set, persistedFormula);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    21
                ]
            ]);
        })),
        getOrderHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isRealTrading) {
                var resetData, key, api, response, _$error, _data, data, message, result, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetData = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                            key = "orderHistory";
                            if (resetData) setIsLoading(key, set, orderHistoryDefault);
                            _ctx.prev = 3;
                            api = !isRealTrading ? order/* getVirtualOrderList */.cf : trade/* default.getOrderList */.Z.getOrderList;
                            _ctx.next = 7;
                            return api(0);
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to retrieve order history failed";
                            setError(_$error, key, set, orderHistoryDefault);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            result = isRealTrading ? transformData/* default.orderList */.ZP.orderList(data) : transformVirtualTradingData.vtOrderList(data);
                            setData(result, message, key, set);
                            store/* default.getState */.Z.getState().searchAndFilter(result);
                            return _ctx.abrupt("return", {
                                data: result,
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, orderHistoryDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(isRealTrading) {
                return _ref.apply(this, arguments);
            };
        }(),
        getExerciseList: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "exerciseList";
                        setIsLoading(key, set);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.getExerciseList */.Z.getExerciseList();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to retrieve exercise list failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        getHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var filters, appendData, key, oldData, response, _$error, _data, data, message, _$error1, ref, page, updatedData, oldData1, transformedHistoryData, isGroupDateExistOnPrevPage, newData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            filters = param.filters, appendData = param.appendData;
                            key = "history";
                            if (Number(filters.page) > 1) {
                                oldData = get().history;
                                set({
                                    history: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, oldData), {
                                        isLoading: true
                                    })
                                });
                            } else {
                                setIsLoading(key, set, historyDefault);
                            }
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.getHistory */.Z.getHistory(filters);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to retrieve history list failed";
                            setError(_$error, key, set, historyDefault);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message, _$error1 = _data.error;
                            if (!_$error1) {
                                _ctx.next = 15;
                                break;
                            }
                            setError(_$error1, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            throw new Error(_$error1);
                        case 15:
                            if (data) {
                                ;
                                page = (filters === null || filters === void 0 ? void 0 : filters.page) || 1;
                                updatedData = [];
                                oldData1 = (ref = get().history.data) === null || ref === void 0 ? void 0 : ref.data;
                                if (data === null || data === void 0 ? void 0 : data.history) {
                                    transformedHistoryData = data.history.reduce(function(prev, curr) {
                                        var _prev;
                                        var isMonthlyRealizedAvailable = typeof curr === "object" && "monthly_gain" in curr;
                                        (_prev = prev).push.apply(_prev, [
                                            (0,_object_spread/* default */.Z)({
                                                groupDate: curr.date
                                            }, isMonthlyRealizedAvailable ? {
                                                groupRealizedGain: curr.monthly_gain
                                            } : {
                                                groupRealizedGain: null
                                            }), 
                                        ].concat((0,_to_consumable_array/* default */.Z)(curr.history_list)));
                                        return prev;
                                    }, []);
                                    if (appendData && oldData1.length && transformedHistoryData.length) {
                                        isGroupDateExistOnPrevPage = (oldData1 === null || oldData1 === void 0 ? void 0 : oldData1.find(function(item) {
                                            var ref;
                                            return item.groupDate === ((ref = transformedHistoryData[0]) === null || ref === void 0 ? void 0 : ref.groupDate);
                                        })) || null;
                                        if (isGroupDateExistOnPrevPage) {
                                            transformedHistoryData.shift();
                                        }
                                        updatedData = (0,_to_consumable_array/* default */.Z)(oldData1).concat((0,_to_consumable_array/* default */.Z)(transformedHistoryData));
                                    } else {
                                        updatedData = transformedHistoryData;
                                    }
                                } else if (appendData && oldData1) {
                                    updatedData = oldData1;
                                }
                                newData = {
                                    data: updatedData,
                                    page: page,
                                    isNeedToFetchMore: page < data.meta.max_page,
                                    totalRealizedAmount: data.meta.total_realized_amount,
                                    tooltipHeader: data.meta.tooltip_header,
                                    tooltips: data.meta.tooltips
                                };
                                setData(newData, message, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                    // @ts-ignore
                                    showSkeleton: false
                                }));
                            }
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         *
         * TODO | SBPD-9819
         * Migrate to use the getHistory API
         * - [ ] Adjust the @params to match /history API
         * - [ ] Adjust the response of the /history
         * - [ ] Transform the response to the legacy UI
         * - [ ] Test
         */ getTransactionHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(urlParams) {
                var key, response, _$error, _data, data, message, _$error1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "transactionHistory";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.getHistory */.Z.getHistory(urlParams);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to retrieve history list failed";
                            setError(_$error, key, set, historyDefault);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message, _$error1 = _data.error;
                            if (_$error1) {
                                setError(_$error1, key, set, {
                                    // @ts-ignore -- TODO:  Fix the type of the store interface
                                    // current implementation has too many instances
                                    // where the types are casted using 'any'
                                    // makes it difficult to achieve static typing
                                    showSkeleton: false
                                });
                            }
                            setData(data, message, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionHistoryDefault), {
                                // @ts-ignore -- Same as above
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", response.data);
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionHistoryDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        16
                    ]
                ]);
            }));
            return function(urlParams) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCompany: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var key, companyResponse, _data, data, _$error, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "company";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return orderbook/* default.getCompanyInfo */.Z.getCompanyInfo(symbol);
                        case 5:
                            companyResponse = _ctx.sent;
                            _data = companyResponse.data, data = _data.data, _$error = _data.error, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 10;
                                break;
                            }
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        14
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCorpActions: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbols) {
                var key, companyResponse, _data, data, _$error, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "corpActions";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return securities/* default.getAllCorpAction */.Z.getAllCorpAction(symbols);
                        case 5:
                            companyResponse = _ctx.sent;
                            _data = companyResponse.data, data = _data.data, _$error = _data.error, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 10;
                                break;
                            }
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        14
                    ]
                ]);
            }));
            return function(symbols) {
                return _ref.apply(this, arguments);
            };
        }(),
        getExercise: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "exercise";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.getExercise */.Z.getExercise(stockCode);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }(),
        checkRightTradeable: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "rightTradeable";
                        setIsLoading(key, set);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.checkRightTradeable */.Z.checkRightTradeable();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to post trade buy failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set);
                        return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        getPortfolioDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, keyDetail, response, _$error, _data, data, message, result, dayTrade;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "portfolioDetail";
                            keyDetail = "portfolioDetailDayTrade";
                            setIsLoading(key, set, portfolioDetailDefault);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.getPortfolioDetail */.Z.getPortfolioDetail(stockCode);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to get portfolio detail failed";
                            setError(_$error, key, set, portfolioDetailDefault);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            result = transformData/* default.portfolioItem */.ZP.portfolioItem(data.result);
                            dayTrade = transformData/* default.portfolioItem */.ZP.portfolioItem(data.day_trade);
                            setData(result, message, key, set, portfolioDetailDefault);
                            setData(dayTrade, message, keyDetail, set, portfolioDetailDefault);
                            return _ctx.abrupt("return", {
                                data: {
                                    result: result,
                                    day_trade: dayTrade
                                },
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, portfolioDetailDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCashOnHand: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "cashOnHand";
                        setIsLoading(key, set, cashOnHandDefault);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.getCashOnHand */.Z.getCashOnHand();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to get cash on hand failed";
                        setError(_$error, key, set, cashOnHandDefault);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set, cashOnHandDefault);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set, cashOnHandDefault);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        // Live Portfolio - LivePrice
        updatePortfolioListItem: function(stockCode, newData) {
            var ref, ref1, ref2;
            if (!stockCode || !newData) return;
            var key = "portfolio";
            var price_latest = newData.price_latest;
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var persistedFormula = get().configFormula;
            if (!persistedFormula) return;
            // Update portfolio list item (Table) - Regular
            var resultList = (ref1 = portfolioData.result) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                if (item.symbol === stockCode) {
                    var updatedData = (0,formula/* generateUpdatedPortfolioItem */.jm)(persistedFormula.data, price_latest, item.balance_lot, item.amount_invested);
                    return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        price_latest: price_latest
                    }), updatedData);
                }
                return item;
            });
            var dayTradeList = (ref2 = portfolioData.day_trade) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                if (item.symbol === stockCode) {
                    var updatedData = (0,formula/* generateUpdatedPortfolioItem */.jm)(persistedFormula.data, price_latest, item.balance_lot, item.amount_invested);
                    return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        price_latest: price_latest
                    }), updatedData);
                }
                return item;
            });
            // Update portfolio summary (Header) - Live Price
            // Update portfolio summary (Header)
            var ref3 = (0,formula/* generateUpdatedPortfolioHeader */.Oz)(persistedFormula.data, resultList, dayTradeList, portfolioData.tradingbalance, portfolioData.amount_invested, portfolioData.amount_allocated, portfolioData.debt_total), unrealised_profitloss = ref3.unrealised_profitloss, gain = ref3.gain, equity = ref3.equity, ratio = ref3.ratio, market_value = ref3.market_value;
            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, portfolioData), {
                result: resultList,
                day_trade: dayTradeList,
                unrealised_profitloss: unrealised_profitloss,
                gain: gain,
                equity: equity,
                debt_ratio: ratio,
                debt_market_value: market_value
            }), "update-portfolio-liveprice", key, set, portfolioDefault);
        },
        // End Live Portfolio - LivePrice
        // Live Portfolio - New WS
        updatePortfolioSummary: function(newData) {
            var ref;
            if (!newData) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            setData((0,_object_spread/* default */.Z)({}, portfolioData, newData), "update-portfolio-data-ws", key, set, portfolioDefault);
        },
        updatePortfolioList: function(newData) {
            var ref;
            if (!newData) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var resultList = newData.result.map(function(item) {
                var ref;
                var oldItem = (ref = portfolioData.result) === null || ref === void 0 ? void 0 : ref.find(function(res) {
                    return res.symbol === item.symbol;
                });
                if (!oldItem) return item;
                return (0,_object_spread/* default */.Z)({}, oldItem, item);
            });
            var dayTradeList = newData.day_trade.map(function(item) {
                var ref;
                var oldItem = (ref = portfolioData.day_trade) === null || ref === void 0 ? void 0 : ref.find(function(res) {
                    return res.symbol === item.symbol;
                });
                if (!oldItem) return item;
                return (0,_object_spread/* default */.Z)({}, oldItem, item);
            });
            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, portfolioData, newData), {
                result: resultList,
                day_trade: dayTradeList
            }), "update-portfolio-data-ws", key, set, portfolioDefault);
        },
        updatePortfolioItem: function(stockCode, newData) {
            var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref, ref1, ref2;
            if (!stockCode || !newData) return;
            var key = "portfolio";
            var portfolioDetailData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioDetailData || !newData) return;
            var portfolioList = isDayTrade ? portfolioDetailData.day_trade : portfolioDetailData.result;
            if (!portfolioList) return;
            // Update portfolio detail if exist
            var resultList = portfolioList.map(function(item) {
                if (item.symbol === stockCode) {
                    return (0,_object_spread/* default */.Z)({}, item, newData);
                }
                return item;
            });
            // Add new portfolio detail if not exist
            var isPortfolioExist = portfolioList.find(function(item) {
                return item.symbol === stockCode;
            });
            if (!isPortfolioExist && resultList) {
                resultList.push(newData);
                resultList.sort(function(a, b) {
                    var symbolA = a.symbol.toUpperCase();
                    var symbolB = b.symbol.toUpperCase();
                    if (symbolA < symbolB) {
                        return -1;
                    }
                    if (symbolA > symbolB) {
                        return 1;
                    }
                    return 0;
                });
            }
            var updatedData = (0,_object_spread/* default */.Z)({}, portfolioDetailData, isDayTrade ? {
                day_trade: resultList
            } : {
                result: resultList
            });
            setData(updatedData, "update-portfolio-item-ws", key, set);
            // update portfolioDetail if exist
            var portfolioDetail = isDayTrade ? (ref1 = get().portfolioDetailDayTrade) === null || ref1 === void 0 ? void 0 : ref1.data : (ref2 = get().portfolioDetail) === null || ref2 === void 0 ? void 0 : ref2.data;
            if (!portfolioDetail) return;
            if (portfolioDetail.symbol === stockCode) {
                var keyDetail = isDayTrade ? "portfolioDetailDayTrade" : "portfolioDetail";
                setData((0,_object_spread/* default */.Z)({}, portfolioDetail, newData), "update-portfolio-detail-ws", keyDetail, set);
            }
        },
        deletePortfolioItem: function(stockCode) {
            var isDayTrade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref, ref1, ref2, ref3, ref4;
            if (!stockCode) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var portfolioList = isDayTrade ? (ref1 = get().portfolio) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.day_trade : (ref3 = get().portfolio) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.result;
            if (!portfolioList) return;
            var resultList = portfolioList.filter(function(item) {
                return item.symbol !== stockCode;
            });
            var updatedData = (0,_object_spread/* default */.Z)({}, portfolioData, isDayTrade ? {
                day_trade: resultList
            } : {
                result: resultList
            });
            setData(updatedData, "update-portfolio-item-ws", key, set);
        },
        updateOrderList: function(newData) {
            var ref;
            if (!newData) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            if (!orderHistoryData) return;
            var orderList = newData.map(function(item) {
                var oldItem = orderHistoryData.find(function(res) {
                    return res.orderid === item.orderid;
                });
                if (!oldItem) return item;
                return (0,_object_spread/* default */.Z)({}, oldItem, item);
            });
            if ((orderList === null || orderList === void 0 ? void 0 : orderList.length) === 0) return;
            setData(orderList, "update-order-list-ws", key, set);
            store/* default.getState */.Z.getState().searchAndFilter(orderList);
        },
        updateOrderListItem: function(orderId, newData) {
            var ref, ref1;
            if (!orderId || !newData) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            var orderHistoryLoading = (ref1 = get().orderHistory) === null || ref1 === void 0 ? void 0 : ref1.isLoading;
            if (!orderHistoryData) return;
            // Update order detail if exist
            var resultList = orderHistoryData.map(function(item) {
                if (item.orderid === orderId) {
                    return (0,_object_spread/* default */.Z)({}, item, newData);
                }
                return item;
            });
            // Add new order detail if not exist
            var isOrderExist = orderHistoryData.find(function(item) {
                return item.orderid === orderId;
            });
            // only update order list if order list is not empty and not loading
            if ((orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.length) === 0 && orderHistoryLoading) return;
            if (!isOrderExist) {
                resultList.unshift(newData);
            }
            setData(resultList, "update-order-item-ws", key, set, orderHistoryDefault);
            store/* default.getState */.Z.getState().searchAndFilter(resultList);
        },
        deleteOrderListItem: function(orderId) {
            var ref;
            if (!orderId) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            if (!orderHistoryData) return;
            var resultList = orderHistoryData.filter(function(item) {
                return item.orderid !== orderId;
            });
            setData(resultList, "delete-order-item-ws", key, set);
            store/* default.getState */.Z.getState().searchAndFilter(resultList);
        },
        // End Live Portfolio - New WS
        checkStockTradable: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, response, _$error, _data, data, message, tradableData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "stockTradable";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.checkStockTradable */.Z.checkStockTradable(stockCode);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to check stock tradable failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            tradableData = data[0];
                            setData(tradableData, message, key, set);
                            return _ctx.abrupt("return", {
                                data: tradableData,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        16
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }()
    };
}), {
    name: "zustandStockbitFormula",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            configFormula: state.configFormula
        };
    }
})));
/* harmony default export */ var tradingData = (tradingDataStore);


/***/ })

}]);